import {
    convertToEnglishNumber,
    RaikoBaseCardContainer, RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoMaterialOutlinedInput, RaikoMoneyInputOutlined, RaikoNumberInputOutlined,
    RaikoSectionContainer,RaikoErrorSection
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../../context/AuthContext";
import {AccountService} from "../../../serverService/account/AccountService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {Skeleton} from "@mui/material";
import {useDebounce} from "@uidotdev/usehooks";
import {RaikoErrorSectionVectors} from "../../../util/RaikoErrorSectionVectors";

export default function AccountDetailLoanInfo({accountId, basicLoading}) {

    const {fundID} = useAuthState()

    const service = new AccountService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Filler,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };

    const [data, setData] = useState({datasets: []});
    const [loanChartLoading, setLoanChartLoading] = useState(true);
    const [loansAmountList, setLoansAmountList] = useState([]);

    const [loanFileKey, setLoanFileKey] = useState("");
    const [loanNumber, setLoanNumber] = useState("");
    const [loanKinds, setLoanKinds] = useState([]);


    useEffect(() => {
        if (accountId) {
            setLoanChartLoading(true)
            service.getLoanInfo(
                fundID,
                accountId
            ).then(({resLoanOffer: loanOffer, resLoanKind: loanKind}) => {
                const label = []
                const amount = []

                for (let i = 1; i <= 100; i++) {
                    label.push(i)
                    amount.push(loanOffer.item[i])
                }


                setLoanFileKey(loanOffer.fileKey)
                setLoanNumber(loanKind.number)

                setLoansAmountList(amount)

                setData({
                    labels: label,
                    datasets: [
                        {
                            fill: true,
                            label: 'وام',
                            data: amount,
                            borderColor: 'rgb(53, 162, 235)',
                            backgroundColor: 'rgba(53, 162, 235, 0.5)',
                        },
                    ],
                })

                loanKind.map((item, index) => {
                    setLoanKinds(prevState => [...prevState, {
                        number: index + 1,
                        id: item.id,
                        name: item.name,
                        codeName: item.codeName
                    }])
                })

            }).catch(reason => {

            }).finally(_ => {
                setLoanChartLoading(false)
            })
        }
    }, [fundID, accountId]);


    const [installmentsCount, setInstallmentsCount] = useState(0);
    const [loanAmount, setLoanAmount] = useState(0);
    const _filterInstallmentCount = useDebounce(installmentsCount, 300)

    useEffect(() => {
        if (_filterInstallmentCount && _filterInstallmentCount > 0) {
            setLoanAmount(loansAmountList[installmentsCount - 1])
        } else {
            setLoanAmount(0)
        }
    }, [_filterInstallmentCount]);


    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"نمودار وام | اقساط"}
                    subTitle={"مقایسه ی وام دریافتی بر اساس تعداد اقساط"}
                >
                    <RaikoGridOneColumn>
                        {
                            !basicLoading && !loanChartLoading ?
                                data && data.datasets && data.datasets.length > 0 ?
                                    <Line
                                        className={css`max-height: 50vh`}
                                        options={options}
                                        data={data}
                                        type={""}
                                    /> :
                                    <RaikoErrorSection
                                        image={RaikoErrorSectionVectors.chartOne}
                                        title={"هیچ اطلاعاتی یافت نشد"}
                                        subTitle={"اطلاعات کافی برای ترسیم نمودار وام اقساط وجود ندارد"}
                                    />
                                : <Skeleton variant="rectangular" className={css`padding: 25vh`}/>
                        }
                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"محاسبه ی وام بر اساس اقساط"}
                >
                    <RaikoGridTwoColumn>
                        <RaikoMaterialOutlinedInput
                            labelText={"اقساط"}
                            value={installmentsCount}
                            setValue={value => {

                                const _value = parseInt(convertToEnglishNumber(value))

                                if (_value >= 0 && _value <= 100) {
                                    setInstallmentsCount(_value)
                                }

                                if (['undefined', 'NAN', 'Nan', 'NaN', '', undefined, NaN].includes(_value)) {
                                    setInstallmentsCount(0)
                                }
                            }}

                        />
                        <RaikoMoneyInputOutlined
                            labelText={"مبلغ وام (ریال)"}
                            value={loanAmount}
                            setValue={setLoanAmount}
                            disabled
                        />
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"نوع وام های قابل دریافت"}
                >
                    <RaikoCustomTable
                        header={[
                            {
                                id: 'number',
                                label: '#',
                                align: 'right',

                            }, {
                                id: 'name',
                                label: 'نام',
                                align: 'right',

                            }, {
                                id: 'codeName',
                                label: 'شناسه',
                                align: 'right',

                            },
                        ]}
                        data={loanKinds}
                        isLoading={false}
                    />

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}
